export default function tabs() {
    const tabContainers = document.querySelectorAll('.spv-tabs');
    function changeTabs(e) {
        const targetTab = e.target;
        const tabList = targetTab.parentNode;
        const tabWrapper = tabList.parentNode;
        const index = parseInt(targetTab.getAttribute('data-index') || '0', 10);
        const stateName = targetTab.getAttribute('data-history-state-name') || 'tab';
        const newHistoryState = { ...history.state, [stateName]: index };
        history.pushState(newHistoryState, '');
        tabList
            .querySelectorAll('[aria-selected="true"]')
            .forEach(t => t.setAttribute('aria-selected', 'false'));
        targetTab.setAttribute('aria-selected', 'true');
        tabWrapper.querySelectorAll('[role="tabpanel"]').forEach(p => p.setAttribute('hidden', 'true'));
        tabWrapper
            .querySelector(`#${targetTab.getAttribute('aria-controls')}`)
            ?.removeAttribute('hidden');
    }
    tabContainers?.forEach(tabContainer => {
        const prefix = tabContainer.getAttribute('data-prefix') || '';
        const historyStateName = 'tab' + prefix;
        const panes = tabContainer.querySelectorAll('.spv-tabs__panel');
        if (panes.length < 2) {
            return;
        }
        const preSelectedIndex = window.history.state && window.history.state[historyStateName]
            ? parseInt(window.history.state[historyStateName], 10)
            : 0 || 0;
        panes.forEach((panel, i) => {
            panel.setAttribute('id', `${prefix}panel-${i}`);
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('tabindex', '0');
            panel.setAttribute('aria-labelledby', `${prefix}tab-${i}`);
            if (i === preSelectedIndex) {
                panel.classList.add('spv-tabs__panel--selected');
            }
            else {
                panel.setAttribute('hidden', 'true');
            }
        });
        const premadeTablist = tabContainer.querySelector('.spv-tabs__tabList');
        let tablist;
        let tabs = [];
        if (premadeTablist) {
            tabs = Array.from(premadeTablist.children);
            tabs.forEach((tab, i) => {
                tab.setAttribute('aria-selected', i === preSelectedIndex ? 'true' : 'false');
                tab.setAttribute('aria-controls', `${prefix}panel-${i}`);
                tab.setAttribute('id', `${prefix}tab-${i}`);
                tab.setAttribute('tabindex', i === preSelectedIndex ? '0' : '-1');
                tab.setAttribute('data-index', i.toString());
                tab.setAttribute('data-history-state-name', historyStateName);
                tab.addEventListener('click', changeTabs);
                if (i === preSelectedIndex) {
                    tab.classList.add('spv-tabs__tabButton--selected');
                }
                else {
                    tab.classList.remove('spv-tabs__tabButton--selected');
                }
            });
            tablist = premadeTablist;
        }
        else {
            tabs = Array.from(panes).map((panel, i) => {
                const title = panel.querySelector('.spv-tabs__title');
                const tab = document.createElement('button');
                tab.classList.add('spv-tabs__tabButton');
                tab.innerHTML = title?.innerHTML || 'Fane uten navn';
                title?.remove();
                tab.setAttribute('role', 'tab');
                tab.setAttribute('aria-selected', i === preSelectedIndex ? 'true' : 'false');
                tab.setAttribute('aria-controls', `${prefix}panel-${i}`);
                tab.setAttribute('id', `${prefix}tab-${i}`);
                tab.setAttribute('tabindex', i === preSelectedIndex ? '0' : '-1');
                tab.setAttribute('data-index', i.toString());
                tab.setAttribute('data-history-state-name', historyStateName);
                tab.addEventListener('click', changeTabs);
                if (i === preSelectedIndex) {
                    tab.classList.add('spv-tabs__tabButton--selected');
                }
                return tab;
            });
            tablist = document.createElement('div');
            tablist.classList.add('spv-tabs__tabList');
            tablist.setAttribute('role', 'tablist');
            tablist.append(...tabs);
        }
        let tabFocus = 0;
        tablist.addEventListener('keydown', e => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                tabs[tabFocus].setAttribute('tabindex', '-1');
                if (e.key === 'ArrowRight') {
                    tabFocus++;
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                }
                else if (e.key === 'ArrowLeft') {
                    tabFocus--;
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }
                tabs[tabFocus].setAttribute('tabindex', '0');
                tabs[tabFocus].focus();
            }
        });
        tabContainer.prepend(tablist);
    });
}
window.addEventListener('DOMContentLoaded', () => {
    console.debug('DOMContentLoaded TABS');
    tabs();
});
//# sourceMappingURL=tabs.js.map